import React from "react";
import styles from "./CustomIcon.module.scss";
import CustomIconProps from "./CustomIconModel";

const CustomIcon: React.SFC<CustomIconProps> = ({ name, style, className = styles.iconClass }: CustomIconProps) => (
  <i className={`icon-${name} ${className}`} style={style} />
);

export default CustomIcon;
